var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bers-intro"},[_c('h3',{staticClass:"bers-intro__headline",domProps:{"innerHTML":_vm._s(_vm.headline)}}),_c('p',{class:_vm.highlighted ? 'bers-intro__text' : '',domProps:{"innerHTML":_vm._s(_vm.introText)}}),(_vm.infoText)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.infoText)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }